import * as React from "react";
import Input from "../Input-new/Input";
import Dropdown from "../Dropdown/Dropdown";

const BuyerCompanyInfo = ({
  data,
  handleChangeInput,
  handleChangeDropdown, 
  viewMode,
  deleted,
}) => {
  return (
    <div className="Buyer-company-info">
      <div className="Buyer-company-info_column">
        <Input
          className="Buyer-company-info_column_item"
          valueType="text"
          name="company_name"
          label="Company Name"
          value={data.company_name}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
        <Input
          className="Buyer-company-info_column_item"
          valueType="text"
          name="company_address"
          label="Company Address"
          value={data.company_address}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
        <Input
          className="Buyer-company-info_column_item"
          valueType="text"
          name="company_city"
          label="City"
          value={data.company_city}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
        <Dropdown
          className="Buyer-company-info_column_item"
          data={data}
          optionsType="states"
          optionKey="abbr"
          optionLabelKey="name"
          value={data.company_state}
          valueKey="company_state"
          label="State"
          handleParentChange={handleChangeDropdown}
          viewMode={viewMode}
          deleted={deleted}
        />
        <Input
          className="Buyer-company-info_column_item"
          valueType="text"
          name="company_zip"
          label="Zip"
          value={data.company_zip}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
      </div>
    </div>
  );
};

export default BuyerCompanyInfo;
